<template>
  <div>
    <Card>
        <Header @QueryHandleClick="QueryHandleClick" @ResetHandleClick="ResetHandleClick"/>
    </Card>
    <Card style="margin-top:1rem">
        <OrderHomeTable :OrderinfoLists="OrderinfoLists" @HandleClick="HandleClick"/>
        <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
    </Card>
  </div>
</template>

<script>
import { OrderMainData } from '../../../../api/Order.js'
import Header from './OrderHomeHeader.vue'
import OrderHomeTable from './OrderHomeTable.vue'
export default {
  name: 'OrderHome',
  components: {
    Header,
    OrderHomeTable
  },
  props: {
    CurrentPageid: String
  },
  watch: {
    CurrentPageid (val) {
      if (val === '小程序订单') {
        this.GetOrderMainData()
      }
    }
  },
  data () {
    return {
      OrderinfoLists: [],
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      SalespersonID: '',
      formItem: {
        OrderID: '',
        State: '',
        Address: '',
        Contacts: '',
        Telephone: '',
        SalespersonID: '',
        Customer_Name: '',
        isAssign: ''
      }
    }
  },
  mounted: function () {
    if (this.$store.state.userInfo.roleName === '销售员') { this.SalespersonID = this.$store.state.userInfo.userID }
    this.GetOrderMainData()
  },
  methods: {
    GetOrderMainData () {
      OrderMainData({
        OrderID: this.formItem.OrderID,
        State: this.formItem.State,
        Address: this.formItem.Address,
        Contacts: this.formItem.Contacts,
        Telephone: this.formItem.Telephone,
        SalespersonID: this.SalespersonID,
        Role: this.$store.state.userInfo.roleName,
        Customer_Name: this.formItem.Customer_Name,
        isAssign: this.formItem.isAssign,
        CurrentPage: this.CurrentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.OrderinfoLists = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetOrderMainData()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetOrderMainData()
      }
    },
    // 点击查询按钮后回调
    QueryHandleClick (res) {
      if (this.$store.state.userInfo.roleName !== '销售员') { this.SalespersonID = res.SalespersonID }
      this.formItem = {
        OrderID: res.OrderID,
        State: res.State,
        Address: res.Address,
        Contacts: res.Contacts,
        Telephone: res.Telephone,
        SalespersonID: res.SalespersonID,
        Customer_Name: res.Customer_Name,
        isAssign: res.isAssign
      }
      this.GetOrderMainData()
    },
    // 点击头部重置后回调
    ResetHandleClick () {
      if (this.$store.state.userInfo.roleName !== '销售员') { this.SalespersonID = '' }
      this.formItem = {
        OrderID: '',
        State: '',
        Address: '',
        Contacts: '',
        Telephone: '',
        SalespersonID: '',
        Customer_Name: '',
        isAssign: ''
      }
      this.GetOrderMainData()
    },
    // 点击办理按钮回调
    HandleClick (OrderID, CustomerName, state) {
      this.$emit('HandleClick', OrderID, CustomerName, state)
    }
  }
}
</script>
